import { Component, HostListener, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../menu-options/menu.serive';
import { SettingsService } from '../settings/settings.service';
import { DataSharingService } from 'app/shared/data-sharing.service';
import { ChatService } from '../chat-list/chat.service';
import { HeaderService } from '../header/header.service';
import { AlertPopup, HttpLoader, MENU_ICON, path } from 'app/app.config';
import { PlayerService } from '../media-player/media-player-service';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AssistBotService } from '../ai-assist/assist-bot.service';
import { LlmService } from 'app/services/llm.service';
import { IndexedDBService } from 'app/services/indexed-db.service';

declare var bootstrap: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  // @Input() menuList: any[];
  @Input() setting: any;
  // @Input() isUserLoggedIn: boolean;
  @Input() currentUser: any;

  isToken: any;
  isUserRole: any;

  mediaContent: any = null;
  subscribers: any = {};

  menuIcon: any = MENU_ICON;

  activeUserChannelList: any[] = [];
  activeChannel = false;
  singleSelect: any;
  companySearch: any;
  searchInList = new Subject<any>();
  isBelowIpadSize: boolean = false;
  isSidebarOpen: boolean = false;
  profileUrl = path.PROFILE_URL;
  companyUrl = path.COMPANY_URL;
  userDetail: any;
  menuList: any = [];
  private sidebarToggleHandler: () => void;
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // Treat as mobile only if width is <= 640px or (>= 765px and <= 768px)
    // Between 641px-764px, treat as desktop (always visible)
    const width = window.innerWidth;
    this.isBelowIpadSize = width <= 640 || (width >= 765 && width <= 768);
    // Close sidebar on resize if switching to desktop
    if (!this.isBelowIpadSize && this.isSidebarOpen) {
      this.closeSidebar();
    }
  }
  
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isBelowIpadSize && this.isSidebarOpen) {
      const sidebar = this.document.querySelector('.sidebar');
      const overlay = this.document.querySelector('.sidebar-overlay');
      const target = event.target as HTMLElement;
      
      // Close if clicking outside sidebar and overlay
      if (sidebar && !sidebar.contains(target) && overlay && !overlay.contains(target)) {
        // Don't close if clicking on the menu toggle button
        const menuToggle = this.document.querySelector('.navbar-burger');
        if (menuToggle && !menuToggle.contains(target)) {
          this.closeSidebar();
        }
      }
    }
  }


  ShowDropdown: boolean = false;

  hostlogo: any;
  constructor(
    private router: Router,
    private menuService: MenuService,
    private settingsService: SettingsService,
    private dataSharingService: DataSharingService,
    private chatService: ChatService,
    private headerService: HeaderService,
    private loader: HttpLoader,
    private alert: AlertPopup,
    private playerService: PlayerService,
    @Inject(DOCUMENT) private document: Document,
    private assistBotService: AssistBotService,
    private llmService:LlmService,
    private indexedDBService: IndexedDBService
    // private elibraryService: ELibraryService
  ) {

  }

  ngOnInit() {
    // this.isUserLoggedIn = true;   

    this.isToken = localStorage.getItem('token');

    if (this.isToken) {
      this.isUserRole = localStorage.getItem('user_role');
      this.isUserRole = parseInt(this.isUserRole.replace(/\"/g, ""));
      this.getMenuList();
      setTimeout(() => {
        this.setting.visible_sidebar = false;
      }, 10000);
    }

    // Treat as mobile only if width is <= 640px or (>= 765px and <= 768px)
    // Between 641px-764px, treat as desktop (always visible)
    const width = window.innerWidth;
    this.isBelowIpadSize = width <= 640 || (width >= 765 && width <= 768);

    // Listen for sidebar toggle events from header
    this.sidebarToggleHandler = () => {
      if (this.isBelowIpadSize) {
        this.toggleSidebar();
      }
    };
    this.document.addEventListener('sidebarToggle', this.sidebarToggleHandler);

    this.router.events.subscribe(
      (event: any) => {
        let sidebar = this.document.querySelector('.sidebar');

        setTimeout(() => {
          if (this.isBelowIpadSize) {
            this.closeSidebar();
          }

          let ngtooltip = this.document.querySelector('.ng-tooltip');
          if (ngtooltip && ngtooltip.classList.contains('ng-tooltip-show')) {
            ngtooltip.classList.remove('ng-tooltip-show');
          }

        }, 300);

      });

  }

  getMenuList() {
    this.headerService.getCurrentUserDetail().subscribe(
      user => {
        this.menuList = user['menuList'];        
      });

    // this.assistBotService.getClientConfig().subscribe((res: any) => {
    //   this.assistBotService.GptConfiguration = res.filter((configlist: any) => configlist['clientModule'] == client)[0]['configuration'];
    // });
  }



  ngAfterViewInit() {

    //bootstrap tooltip
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });


    if (this.isToken) {
      this.getMenuList();
    }
    this.subscribers.notifyCount = this.dataSharingService.getNotifyCount().subscribe(menuObj => {

      // console.log(this.menuList)

      const actualMenuList = [...this.menuList];
      const newMenuObj = actualMenuList.find(ml => ml.menu_name === menuObj.menu);

      if (menuObj.count) {
        newMenuObj.notify_count = menuObj.count;
        return;
      }

      if (newMenuObj.notify_count) {
        newMenuObj.notify_count += 1;
      } else {
        newMenuObj.notify_count = 0;
        newMenuObj.notify_count += 1;
      }
      this.menuList = actualMenuList;
    })


    this.subscribers.media = this.playerService.getMediaContent().subscribe(response => {
      if (this.mediaContent && response) {
        if (this.mediaContent.file_path !== response.file_path) {
          this.mediaContent = response;
        }
      } else {
        this.mediaContent = response;
      }
    }, error => console.log(error))

    if (this.isToken) {
      this.settingsService.getUserSettings().subscribe((res: any) => {
        this.userDetail = res['userDetail'];
        this.indexedDBService.userDetail = this.userDetail;
      });
    }



  }

  urlFormation(menuName) {
    if (menuName) {
      return menuName.replace(/_/g, '');
    }
  };


  /**
 * Chang the hide sidemenu style
 * @param value
 */
  hideSideMenu() {
    try {
      const payLaod = {
        visible_sidebar: !this.setting.visible_sidebar
      };
      const settingObj = { ...this.setting }
      settingObj.visible_sidebar = !this.setting.visible_sidebar;
      this.setting = settingObj;
      this.settingsService.updateUserSettings(payLaod).subscribe(
        response => {
        },
        error => {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }

    if (this.isBelowIpadSize) {
      this.toggleSidebar();
    }
  }
  
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    // Prevent body scroll when sidebar is open on mobile
    if (this.isSidebarOpen) {
      this.document.body.style.overflow = 'hidden';
      // Ensure sidebar has show class for CSS
      const sidebar = this.document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.classList.add('show');
      }
    } else {
      this.document.body.style.overflow = '';
      // Remove show class
      const sidebar = this.document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.classList.remove('show');
      }
    }
  }
  
  closeSidebar() {
    if (this.isSidebarOpen) {
      this.isSidebarOpen = false;
      this.document.body.style.overflow = '';
      // Remove show class
      const sidebar = this.document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.classList.remove('show');
      }
    }
  }
  
  openSidebar() {
    if (!this.isSidebarOpen) {
      this.isSidebarOpen = true;
      this.document.body.style.overflow = 'hidden';
      // Add show class
      const sidebar = this.document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.classList.add('show');
      }
    }
  }

  removeNotifyCount(menuObj) {
    menuObj.notify_count = 0;
  };


  ngOnDestroy(): void {
    this.subscribers.notifyCount.unsubscribe();
    this.subscribers.media.unsubscribe();
    this.activeChannel = false;
    // Remove event listener
    if (this.sidebarToggleHandler) {
      this.document.removeEventListener('sidebarToggle', this.sidebarToggleHandler);
    }
    // Restore body overflow
    this.document.body.style.overflow = '';
  }

  showSearchBox(toggle) {
    console.log(toggle);

  }

  displayUserFirstLetter(userName) {
    if (userName) {
      return userName.charAt(0).toUpperCase();
    } else {
      return;
    }
  }

  showuserMenu() {
    this.ShowDropdown = !this.ShowDropdown;
  }

  toggleSideMenu() {
    this.setting.visible_sidebar = !this.setting.visible_sidebar;
  }

  logout() {
    const payload = {
      user_id: this.currentUser.user_id,
      status_id: 0
    }
    let llm_token = localStorage.getItem("llm_token");
    if (llm_token) {

      // this.headerService.LLmLogout(this.assistBotService.GptConfiguration["LLm_url"] + "logout", llm_token).subscribe((res: any) => {

      // });
      this.llmService.llmUserLogout({"client_id":localStorage.getItem("company_id")}).subscribe((res:any)=>{

      });
    }
    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
      this.router.navigate(['/login']);
    });


  }

}
